/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import configENV from '../../../../../Account/config'
import { Grid, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import { getBrandName } from '../../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { icons } from '../../assets/icons';

const useStyles = makeStyles((theme) => ({
   recipientMessageContainer: {
      backgroundColor: theme.palette.thankyoucards.bgColor,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: '4.5rem',
      height: 'auto',
      padding: theme.spacing(2),
      overflowX: 'hidden',
      '& h3': {
        margin: theme.spacing(2, 0),
        textAlign: 'center',
      },
      '& img': {
        maxWidth: '100%',
        height: 'auto',
        borderRadius: 10,
        margin: theme.spacing(2, 0),
      },
      '& p': {
        textAlign: 'start',
      },
      '& button': {
        borderRadius: '3px',
        backgroundColor: theme.palette.thankyoucards.primaryColor,
        color: theme.palette.common.white,
        padding: theme.spacing(1, 3),
        textTransform: 'none',
        '&:focus, &:hover, &:active': {
         backgroundColor: theme.palette.thankyoucards.primaryColor,
       },
      },
   },
   recipientMessageInnerContainer: {
      display: 'flex',
      fontFamily: theme.palette.thankyoucards.typography,
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: '-webkit-center',
      alignItems: 'center'
   },
   specialMessage: {
      margin: '44px 0 32px 0',
      '& p': {
         fontFamily: theme.palette.thankyoucards.titleTypography,
         fontWeight: 700,
         fontSize: '24px',
         lineHeight: '35px',
         letterSpacing: '0.01em',
         color: theme.palette.common.black,
         textAlign: 'center!important',
         margin: '0px',
      },
      '@media screen and (max-width: 280px)': {
         fontSize: '20px'
     },
   },
   subtitle: {
      fontStyle: 'normal',
      fontWeight: 700,
      fontSize: '14px',
      lineHeight: '17px',
      letterSpacing: '0.01em',
      color: theme.palette.common.black,
   },
   giftMessage: {
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '17px',
      letterSpacing: '0.01em',
      color: theme.palette.common.black,
      paddingTop: '1rem'
   },
   thanksBtn: {
      marginTop: '25px',
      '& button': {
         width: '100%',
         height: '43px',
         fontWeight: '700',
         whiteSpace: 'nowrap',
         border: 'none',
         fontSize: '16px',
         textTransform: 'none',
         '@media screen and (max-height: 670px)': {
            fontSize: '14px'
        },
        '&:focus, &:hover, &:active': {
           backgroundColor: theme.palette.thankyoucards.primaryColor,
        },
      },
      '& a': {
         textDecoration: 'none'
      }
   },
   giftMessageContainer: {
      backgroundColor: theme.palette.common.white,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: 'auto',
      maxHeight: '203px',
      overflow: 'auto',
      padding: '1rem',
      '& p': {
         margin: '0px'
      }
   },
   videoContainer: {
      position: 'relative',
      height: '300px',
      '& video': {
         background: '#f2f2f2', 
         objectFit: 'cover'
      }
   },
   customControls: {
      position: 'absolute',
      top: '35%',
      left: '35%',
      opacity: 0.6,
      '@media screen and (max-width: 350px)': {
         left: '30%',
      },
   },
   contentContainer: {
      height: '100%',
   },
   contentContainerNonCardisle: {
      width: '75%',
   },
   cardIsleIframe: {
      border: 'none',
   },
 }));

const { SMART_GIFT_URL, CARDISLE_URL } = configENV;

const RecipientYourMessageTab = ({ cardIsleParams, ...props }) => {
   const headerclip = 'https://assets.contentstack.io/v3/assets/bltdd99f24e8a94d536/blte58827fb41aa6afd/648b1d2848e15a1e1546ade8/samplevideo.mp4';
   const {
      items = {},
      recipientProfiles = [],
      billingProfile = {},
   } = props.recipientVerifyData?.data?.[0]?.orders || {};

   const dispatch = useDispatch();
   const [showButton, setShowButton] = useState(false);
   const [isPlaying, setIsPlaying] = useState(false);
   const videoRef = useRef();

   const brand = useSelector(getBrandName) || '1800flowers';

   const classes = useStyles();
   const recipientName = recipientProfiles[0]?.firstName || '';
   const cardMessage = items?.cardMessage || '';
   const senderName = billingProfile?.firstName || '';
   const recipientToken = props.recipientVerifyData?.token || '';
   const thankSenderLink = `https://${brand + SMART_GIFT_URL + recipientToken}${`&id=${cardIsleParams || ''}`}`;
   const cardIsleLink = CARDISLE_URL + cardIsleParams;
   const orderNumber = props.recipientVerifyData.ROSSOrder[0]._id || '';

   const togglePlay = (e) => {
      e.preventDefault();
      const video = videoRef.current;
      setShowButton(true);
      if (isPlaying) {
         video.pause();
         setIsPlaying(false);
      } else {
         video.play();
         setIsPlaying(true);
      };
  };

  const cardisleEventListener = (event) => {
      // verify that message came from Card Isle
      if (event.origin !== 'https://www.cardisle.com') {
         return;
      };

      if (event.data.indexOf('iframe-height') > -1) {
         document.getElementById('cardisleiframe').setAttribute('height', event.data.split(':').pop());
      };
   };

   const handleDisplayButton = (status) => {
      if (typeof status !== 'undefined') {
         setShowButton(status)
      } else if (videoRef.current.currentTime > 0 && !videoRef.current.paused && videoRef.current.currentTime !== videoRef.current.duration) {
         setIsPlaying(true);
         setShowButton(true);
      } else {
         setIsPlaying(false);
         setShowButton(true);
      };
   };

   const renderVideo = () => {

      if (cardIsleParams) {
         return <iframe id="cardisleiframe" className={classes.cardIsleIframe} src={cardIsleLink} title="Cardisle video iframe" />
      };

      return (
         <React.Fragment>
            <Grid item className={classes.videoContainer} onClick={(e) => togglePlay(e)} onMouseEnter={() => handleDisplayButton(true)} onMouseLeave={() => handleDisplayButton(false)} onMouseMove={() => handleDisplayButton()}>
               <video onEnded={() => { setShowButton(true); setIsPlaying(false) }} playsInline type="video/mp4" height="100%" width="100%" ref={videoRef} autoPlay muted>
                  <source src={cardIsleParams ? cardIsleLink : headerclip} />
               </video>
               <div className={classes.customControls}>
                  {showButton && (isPlaying ? icons.pauseIcon : icons.playIcon )}
               </div>
            </Grid>
            <Grid className={classes.giftMessageContainer}>
               <p className={classes.subtitle}>To: {recipientName}</p>
               <p className={classes.subtitle}>From: {senderName}</p>
               <p className={classes.giftMessage}>{cardMessage}</p>
            </Grid>
         </React.Fragment>
      )
   };

   useEffect(() => {
      if (window !== 'undefined') {
         window.addEventListener('message', cardisleEventListener);
      };

      return () => {
         window.removeEventListener('message', cardisleEventListener);
      };
   }, []);
   
  return (
      <Grid id={`section-${props.id}`} ref={props.reference} className={classes.recipientMessageContainer}>
         <Grid item className={classes.recipientMessageInnerContainer}>
            <Grid item className={classes.specialMessage}>
               <p>A Special Message for You</p>
            </Grid>
            <Grid item className={cardIsleParams ? `${classes.contentContainer}` : `${classes.contentContainer} ${classes.contentContainerNonCardisle}`}>
               {renderVideo()}
               <Grid className={classes.thanksBtn}>
                  <a href={thankSenderLink} rel="noopener noreferrer" onClick={() => dispatch(trackEvent({
                     eventCategory: 'CTA Click',
                     eventAction: 'Send A Thank You Back',
                     eventLabel: orderNumber,
                  }))}>
                     <Button disableRipple>Send A Thank You Back</Button>
                  </a>
               </Grid>
            </Grid>
         </Grid>
      </Grid>
   )
};

export default RecipientYourMessageTab;